import { connect } from 'react-redux'
import TripsHistoryPane from '../../components/trips/TripsHistoryPane'
import { IStoreState } from '../../types/index'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {}
}

const mapDispatchToProps = (dispatch: any) => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TripsHistoryPane)



// WEBPACK FOOTER //
// ./src/containers/trips/TripsHistory.ts